import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.network.dns.domain.transfer.list;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_DNS_DOMAIN_TRANSFER_LIST',
	method: 'POST',
	url: '/network/dns/domain/transfer/list.json',
});

export { actions, reducer, sagas, selectors };
